import * as types from './mutation-types'

export const loadCategories = ({ commit, dispatch, state },restaurant) => {
    let data = {
        children: true
    }
    return new Promise((resolve, reject) => {
        window.axios.post(`customer/get/${restaurant}/categories`, data).then((response) => {
            commit(types.LOAD_CATEGORIES, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadCategoryMeals = ({ commit, dispatch, state }, data) => {
    if(data.category){
        return new Promise((resolve, reject) => {
            window.axios.get( `customer/${data.restaurant}/category/${data.category}/meals`).then((response) => {
                // commit(types.LOAD_CATEGORIES, response.data)
                resolve(response)
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export const loadMeal = ({ commit, dispatch, state },id) => {
    return new Promise((resolve, reject) => {
        window.axios.get( `customer/meals/${id}/details`).then((response) => {
           // commit(types.LOAD_CATEGORIES, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}